(function() {
    'use strict';

    var extDeps = [];
    var module = angular.module('app.common.widgets.notifications',extDeps);






    //--------------------------



    /**
     * NOTIFICATIONS
     */


    module.factory('notificationsInboxService', notificationsInboxService );
    notificationsInboxService.$inject = ['$rootScope', 'NotificationsApi'];
    function notificationsInboxService( $rootScope, NotificationsApi){

        return {
             onMessageRead: onMessageRead
            , getUnreadMessagesCountAsync: getUnreadMessagesCountAsync
            , getMessagesBeforeAsync: getMessagesBeforeAsync
            , setMessageAsReadAsync: setMessageAsReadAsync
            , deleteNotificationAsync: deleteNotificationAsync
        };

        function getMessagesBeforeAsync(notificationID,pageSize){
            return NotificationsApi.query({ lastID:notificationID, pageSize:pageSize})
                .$promise;
        }

        function setMessageAsReadAsync(id){
            return NotificationsApi.markAsRead({id:id})
                .$promise
                .then(notify);
        }

        function getUnreadMessagesCountAsync(){
            return NotificationsApi.getUnreadCount()
                .$promise;
        }


        function onMessageRead( handler, scope){
            if(handler && scope)
                scope.$on('messageRead', handler);
        }

        function deleteNotificationAsync(id){
            return NotificationsApi.delete({id:id})
                .$promise
                .then(notify);
        }


        function notify(){
            $rootScope.$broadcast("messageRead");
        }
    }


    /**
     * provides the notifications popover functionality
     */
    module.directive('notificationsInboxButton', notificationsInboxButtonDirective);
    notificationsInboxButtonDirective.$inject =['$compile','$timeout', '$rootScope'];
    function notificationsInboxButtonDirective($compile,$timeout, $rootScope){
        return {
            restrict: 'E',
            scope: false,
            templateUrl:'/UI/app/common.widgets/notificationsInboxButton.html',
            controller: controller,
            controllerAs: 'dvm',
            link: linkFn
        };


        function linkFn(scope, element, attrs) {

            var $bellBtn = element.find('button')
                .popover({
                    placement : attrs.placement || 'bottom',
                    cssClass: attrs.style || '',
                    html: true,
                    //container:'body',
                    content: function (){ return '<code></code>'; }
                })
                .on('inserted.bs.popover', function(){
                    var flyoutId = $(this).attr('aria-describedBy');
                    var template = '<ng-include src="\'/UI/app/common.widgets/notificationsList.html\'"></ng-include>';

                    $timeout(function(){
                        var linkFn = $compile(template);
                        var content = linkFn(scope);
                        $('#'+ flyoutId +' code').replaceWith(content);
                    },0);

                    $(window).on('resize',{target:flyoutId},repositionFlyoutOnWindowResize);
                    $('div.app-wrapper').on('click',$bellBtn,hideFlyout);
                })
                .on('hide.bs.popover',function(){
                    var flyoutId = $(this).attr('aria-describedBy');
                    $(window).off('resize',repositionFlyoutOnWindowResize);
                    $('div.app-wrapper').off('click',$bellBtn,hideFlyout)
                });


            //Hide notification panel when navigating with back button
            scope.$on('$stateChangeSuccess',function(a,b,c,d){
                hideFlyout({data:$bellBtn});
            });
        }

        function hideFlyout(payload){
            if(!payload.context && $(payload.target).closest('notifications-inbox-button').length)
                return;


            var $bellBtn = payload.data;
            if($bellBtn.data()['bs.popover'].inState.click)
                $bellBtn.click();
        }

        function repositionFlyoutOnWindowResize(e) {
            angular.element('#' + e.data.target)
                .css("right", "15px")
                .css("left", "auto");
        }

        function controller($scope,$timeout, debounce,notificationsInboxService){
            var vm = this;
            var _refreshCount = (function(f){ return debounce(f, 500, false);})(_refreshCountFunc);
            _init();

            function _init(){
                notificationsInboxService.onMessageRead(_refreshCount,$scope);
                _refreshCount();
            }

            function _refreshCountFunc(){
                return notificationsInboxService.getUnreadMessagesCountAsync()
                    .then(function(results){
                        vm.messageCount = results.unreadCount;
                        _scheduleNextRefresh();
                    });
            }

            function _scheduleNextRefresh(){
                $timeout(_refreshCountFunc, 60000);
            }
        }

    }



    module.controller('HeaderNotificationController', HeaderNotificationController);
    HeaderNotificationController.$inject = ['$q', '$state',  'modalService', 'notificationsInboxService', 'lodash'];
    function HeaderNotificationController($q, $state,  modalService, notificationsInboxService, lodash) {
        var vm = this;
        vm.notifications = [];
        vm.loadInProgress = false;
        vm.moreNotificationsAvailable = false;
        vm.showMessage = showMessageDialogAsync;
        vm.deleteNotification = deleteNotificationAsync;
        vm.loadMoreNotifications = loadMoreNotificationsAsync;
        init();


        function init() {
            loadMoreNotificationsAsync();
        }


        function loadMoreNotificationsAsync() {
            vm.loadInProgress = true;

            var lastId = null;
            if((vm.notifications || {}).length)
                lastId = vm.notifications[vm.notifications.length - 1].notificationID;

            var pageSize = 10;

            return notificationsInboxService.getMessagesBeforeAsync(lastId, pageSize + 1)
                .then(function (results) {

                    // trick to hide the loadMorebutton when there are no more notifications left
                    vm.moreNotificationsAvailable = false;
                    if(results.length > pageSize){
                        results = lodash.dropRight(results, 1);
                        vm.moreNotificationsAvailable = true;
                    }

                    vm.notifications = lodash.unionBy(vm.notifications, results, 'notificationID');
                }).finally(function () {
                    vm.loadInProgress = false;
                });
        }

        function showMessageDialogAsync(msg){

            notificationsInboxService.setMessageAsReadAsync(msg.notificationID)
                .then(function () {
                    // if it is of type news, then go to detail directly instead of opening a modal dialog
                    // has to be inside promise to prevent async ajax errors
                    if((/news/i).test(msg.type)){
                        $state.go('enterModule',{name:'news',payload: {'id':msg.body}});
                    }
                });

            if (msg.status == "Unread") {
                msg.status = "Read";
            }

            // do not open a modal if it is a news item
            if((/news/i).test(msg.type))
                return $q.resolve();

            var options = {
                templateUrl: '/UI/app/common.widgets/notificationDialog.html'
                , controller : 'NotificationDialogController'
                , payload : msg
            };

            return modalService.openCustom(options)
                .then(function(result){
                    if((/delete/i).test(result))
                        deleteNotificationAsync(msg)
                });
        }


        function deleteNotificationAsync(msg){
            vm.loadInProgress = true;
            return notificationsInboxService.deleteNotificationAsync(msg.notificationID)
                .then(function(){

                    lodash.remove(vm.notifications, function(x){ return x.notificationID === msg.notificationID});
                    if(vm.notifications.length===0)
                        return loadMoreNotificationsAsync();
                    else
                        return true;
                })
                .finally(function () {
                    vm.loadInProgress = false;
                });

        }

    }



    module.controller('NotificationDialogController',NotificationDialogController);
    NotificationDialogController.$inject = [ '$scope','$state', '$timeout','modalPayload'];
    function NotificationDialogController($scope, $state,$timeout, modalPayload) {
        var vm = this;
        vm.title = null;
        vm.body = null;
        vm.dismissDialog = dismissDialog;
        vm.deleteNotification = deleteNotification;

        init();

        function init(){
            vm.title = modalPayload.subject;
            vm.body = modalPayload.body
                .replace(/[_]{10,}([\n]+)?/g,'<hr/>')
                .replace(/[\n]+/g,'<br/>');

            askConfirmationWhenExitingForm.remove = $scope.$on('$stateChangeStart',askConfirmationWhenExitingForm);
        }

        function dismissDialog(){
            $scope.$dismiss('Cancel');
        }

        function deleteNotification(){
            $scope.$close('Delete');
        }

        // Allows the user exiting the modal with the back button
        function askConfirmationWhenExitingForm(event, toState, toParams, fromState){
            event.preventDefault();
            $state.go(fromState);
            dismissDialog();
        }
    }



})();

